import api from "./api";
import config from "../config";
import { convertToPassBucketless } from "./PassUtil";

export default {
  fetchAll(person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/self/passes_including_global`,
          qs: { token: person, event_bucket: config.event_bucket }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.passes.map(convertToPassBucketless));
        }
      );
    });
  },

  fetchOne(person, pass) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `passes/${pass}`,
          qs: { token: person }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(convertToPassBucketless(response));
        }
      );
    });
  },

  fetchTypes(person, opts) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}/pass_buckets`,
          qs: {
            token: person,
            conditions:
              opts && opts.passBucketIds
                ? JSON.stringify({ _id: { $in: opts.passBucketIds } })
                : undefined
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.pass_buckets);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/PassFetcher.js